<mg-menu-header-items
  [routes]="data.items"
  [profileMenu]="data.type === 'profile'"
  [showThemeOptions]="showThemeOptions"
  (itemClicked)="bottomSheetRef.dismiss()"
  (themeOptionsStatusChanged)="showThemeOptions = $event"
></mg-menu-header-items>
